import Ajax from '@utils/ajax';

export function clearDemoData() {
	return Ajax.post('/clear-demo-data');
}
